import { useNavigate } from 'react-router-dom';
import { Chip, DropdownMenuItem } from '@c2fo/liquidity';
import { EyeIcon } from '@c2fo/liquidity/icons';
import { DeliveryDisplay } from '../../api/Deliveries';
import { DataGrid, DataGridCard } from '../DataGrid';
import { ActionsMenu } from '../ActionsMenu';
import { getStateChipType, getStateLabel } from '../../utils';
import { formatDateWithTimezone } from '../../../../utils/dateFormat';

interface DeliveryGridProps {
  deliveries: DeliveryDisplay[];
}

export const DeliveryGrid: React.FC<DeliveryGridProps> = ({ deliveries }) => {
  const navigate = useNavigate();

  return (
    <DataGrid>
      {deliveries.map((delivery) => (
        <DataGridCard key={delivery.name}>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Chip
                label={delivery.scheduledDelivery ? 'Scheduled' : 'Immediate'}
                type={delivery.scheduledDelivery ? 'primary' : 'warning'}
                variant="outlined"
                size="xs"
              />
              <Chip
                label={getStateLabel(delivery.state)}
                type={getStateChipType(delivery.state)}
                variant="outlined"
                size="xs"
              />
            </div>
            <ActionsMenu>
              <DropdownMenuItem
                className="active:bg-lightBlue-100"
                onSelect={() => navigate(`/file-delivery/${delivery.name}`)}
              >
                <EyeIcon className="h-4 w-4 mr-2" />
                View Details
              </DropdownMenuItem>
            </ActionsMenu>
          </div>

          <div className="text-xs text-gray-500 truncate" title={delivery.name}>
            {delivery.name}
          </div>

          <div className="flex flex-col gap-1 text-xs text-gray-500">
            <div className="flex items-center gap-1">
              <span className="font-medium">Target:</span>
              <span className="truncate">{delivery.targetLocation ?? 'Unknown'}</span>
            </div>
          </div>

          <div className="text-xs text-gray-500">
            <span className="font-medium">Time:</span>{' '}
            {delivery.endTime ? formatDateWithTimezone(delivery.endTime) : '-'}
          </div>
        </DataGridCard>
      ))}
    </DataGrid>
  );
};
